import { type AlertProps } from '@pets-ui/Alert/Alert'
import { Alert } from '@pets-ui/Alert/Alert'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { typography } from '@pets-ui/tokens/typography.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  root: {
    alignItems: 'center',
    fontSize: typography.sizeBody,
  },
  icon: {
    color: colors.blue600,
    fontSize: typography.sizeBody,
  },
  message: {
    fontSize: typography.sizeBody,
  },
  action: {
    color: colors.blue600,
    fontSize: typography.sizeBody,
  },
})

export type ButlerItemAlertProps = AlertProps

export const ButlerItemAlert = (props: ButlerItemAlertProps) => {
  const { xStyles, ...rest } = props
  return (
    <Alert xStyles={{ ...styles, ...xStyles }} {...rest} />
  )
}
